import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {IntCalendarCellComponent} from "./calendar-cell.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntCalendarCellComponent
  ],
  exports: [
    IntCalendarCellComponent
  ]
})
export class IntCalendarCellModule {

}
